import React from "react";
import { Route, Routes } from "react-router-dom";
import ConsumptionRegister from "../screens/ConsumptionRegister/ConsumptionRegister";
import NotFound from "../screens/NotFound";
import ResourceHistory from "../screens/ConsumptionRegister/ConsumptionHistory/ResourceHistory";

const ConsumptionRegisterRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<ConsumptionRegister />} />
      <Route
        path="/historial/:resource/*"
        element={
          <Routes>
            <Route path="/" element={<ResourceHistory />} />
            <Route path="/*" element={<NotFound />} />
          </Routes>
        }
      />
    </Routes>
  );
};

export default ConsumptionRegisterRoutes;
